import Vue from 'vue';
import Router from 'vue-router';
import Login from '@/components/pages/login/Login.vue';
import SolicitarTrocarSenha from '@/components/pages/login/SolicitarTrocarSenha';
import TrocarSenha from '@/components/pages/login/TrocarSenha';
import Home from '@/components/pages/home/Home.vue';
import Feriados from '@/components/pages/cadastro/feriados/Feriados.vue';
import Justificativas from '@/components/pages/cadastro/justificativas/Justificativas.vue';
import MotivoAfastamentos from '@/components/pages/cadastro/motivoAfastamentos/MotivoAfastamentos.vue';
import Empresas from '@/components/pages/cadastro/empresas/Empresas.vue';
import ListaEmpresas from '@/components/pages/cadastro/empresas/ListaEmpresas.vue';
import NovaEmpresa from '@/components/pages/cadastro/empresas/NovaEmpresa.vue';
import Cargos from '@/components/pages/cadastro/cargos/Cargos.vue';
import CentrosCustos from '@/components/pages/cadastro/centrosCustos/CentrosCustos.vue';
import Escalas from '@/components/pages/cadastro/escalas/Escalas.vue';
import NovaEscala from '@/components/pages/cadastro/escalas/NovaEscala.vue';
import ListaEscalas from '@/components/pages/cadastro/escalas/ListaEscalas.vue';
import ClienteApp from '@/components/pages/cadastro/dispositivosColetas/ClienteApp.vue';
import Relatorios from '@/components/pages/relatorios/Relatorios.vue';
import Divergencias from '@/components/pages/relatorios/Divergencias';
import EspelhoPonto from '@/components/pages/relatorios/EspelhoPonto';
import HorasTrabalhadas from '@/components/pages/relatorios/HorasTrabalhadas';
import HorasExtrasAnalitico from '@/components/pages/relatorios/HorasExtrasAnalitico';
import Interjornada from '@/components/pages/relatorios/Interjornada';
import IntervaloAlmoco from '@/components/pages/relatorios/IntervaloAlmoco';
import DomingosTrabalhados from '@/components/pages/relatorios/DomingosTrabalhados';
import SaldoBancoHorasRelatorio from '@/components/pages/relatorios/SaldoBancoHoras';
import PontoExterno from '@/components/pages/relatorios/PontoExterno';
import EscalaFolga from '@/components/pages/cadastro/escalaFolga/EscalaFolga';
import Documentos from '@/components/pages/documentos/Documentos.vue';
import ArquivoFiscal from '@/components/pages/documentos/ArquivoFiscal.vue';
import ArquivoAFD from '@/components/pages/documentos/ArquivoAFD.vue';
import ArquivoFolha from '@/components/pages/documentos/ArquivoFolha.vue';
import MeusDados from '@/components/pages/usuario/MeusDados.vue';
import ListaUsuarios from '@/components/pages/usuario/ListaUsuarios.vue';
import Usuarios from '@/components/pages/usuario/Usuarios.vue';
import EditarUsuario from '@/components/pages/usuario/EditarUsuario.vue';
import LogOperacao from '@/components/pages/logOperacao/LogOperacao.vue';
import PerfilPermissao from '@/components/pages/perfilPermissao/PerfilPermissao.vue';
import PoliticaPrivacidade from '@/components/pages/politicaPrivacidade/politica-privacidade.vue';
import Funcionarios from '@/components/pages/cadastro/funcionarios/Funcionarios.vue';
import ListaFuncionarios from '@/components/pages/cadastro/funcionarios/ListaFuncionarios.vue';
import NovoFuncionario from '@/components/pages/cadastro/funcionarios/NovoFuncionario.vue';
import EditaFuncionario from '@/components/pages/cadastro/funcionarios/EditaFuncionario.vue';
import Ocorrencias from '@/components/pages/movimento/ocorrencias/Ocorrencias.vue';
import MudancaHorario from '@/components/pages/movimento/mudancaHorario/MudancaHorario.vue';
import BancoHoras from '@/components/pages/movimento/saldoBancoHoras/BancoHoras.vue';
import CalculoPonto from '@/components/pages/movimento/calculoPonto/CalculoPonto.vue';
import ControlePonto from '@/components/pages/movimento/controlePonto/ControlePonto.vue';
import Controle from '@/components/pages/movimento/controlePonto/Controle.vue';
import MarcacoesFuncionario from '@/components/pages/movimento/controlePonto/MarcacoesFuncionario.vue';
import ConcluirFecharPerido from '@/components/pages/movimento/controlePonto/ConcluirFecharPeriodo.vue';
import Afastamentos from '@/components/pages/movimento/afastamentos/Afastamentos.vue';
import NaoAutorizado from '@/components/pages/erro/naoAutorizado/NaoAutorizado.vue';
import Erro404 from '@/components/pages/erro/erro404/Erro404.vue';
import ImportarFuncionarios from '@/components/pages/cadastro/funcionarios/importar/ImportarFuncionarios.vue';
import Configurar from '@/components/pages/cadastro/funcionarios/importar/Configurar.vue';
import Validar from '@/components/pages/cadastro/funcionarios/importar/Validar.vue';
import Confirmar from '@/components/pages/cadastro/funcionarios/importar/Confirmar.vue';
import Orientacoes from '@/components/pages/cadastro/funcionarios/importar/Orientacoes.vue';
import Finalizar from '@/components/pages/cadastro/funcionarios/importar/Finalizar.vue';
import Dashboard from '@/components/pages/dashboard/Dashboard.vue';
import RelogioPonto from '@/components/pages/cadastro/dispositivosColetas/RelogioPonto.vue';
import MarcacoesLocalRelogio from '@/components/pages/relatorios/MarcacoesLocalRelogio.vue';
import AutorizacaoSuporete from '@/components/pages/autorizacaoSuporte/AutorizacaoSuporte.vue';
import MarcacaoOnline from '@/components/pages/cadastro/dispositivosColetas/MarcacaoOnline.vue';
import OcorrenciaJustificada from '@/components/pages/relatorios/OcorrenciaJustificada.vue';
import Solicitacoes from '@/components/pages/movimento/solicitacoes/Solicitacoes.vue';
import ComprovanteMarcacao from '@/components/pages/documentos/ComprovanteMarcacao.vue';
import Mensagem from '@/components/pages/usuario/Noticia.vue';
import Sobre from '@/components/pages/sobre/Sobre.vue';
import HistoricoRelatorios from '@/components/pages/relatorios/HistoricoRelatorios.vue';
import MonitoramentoPush from '@/components/pages/cadastro/dispositivosColetas/sinc/MonitoramentoPush.vue';

import store from '@/plugins/store/store';

Vue.use(Router);

const router = new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			component: Home,
			meta: {
				loginRequerido: true,
				permissao: 0				
			},
			children: [
				{
					path: '',
					component: Dashboard,
					meta: {
						loginRequerido: true,
						permissao: 0			
					}             
				},
				{
					path: '/cadastros/empresas',
					component: Empresas,
					meta: {
						loginRequerido: true,
						permissao: 29		
					},
					children: [
						{path: '', component: ListaEmpresas, meta: {loginRequerido: true, permissao: 29}},
						{path: 'nova', component: NovaEmpresa, meta: {loginRequerido: true, permissao: 30}},
						{path: ':id/editar', component: NovaEmpresa, props: true, meta: {loginRequerido: true, permissao: 32}}
					]
				},				
				{
					path: '/cadastros/dispositivos-coletas/cliente-app',
					component: ClienteApp,
					meta: {
						loginRequerido: true,
						permissao: 142			
					}             
				},
				{
					path: '/cadastros/dispositivos-coletas/relogio-ponto',
					component: RelogioPonto,
					meta: {
						loginRequerido: true,
						permissao: 153			
					}             
				},
				{
					path: '/cadastros/dispositivos-coletas/marcacao-online',
					component: MarcacaoOnline,
					meta: {
						loginRequerido: true,
						permissao: 160			
					}             
				},
				{
					path: '/cadastros/dispositivos-coletas/monitoramento-push',
					component: MonitoramentoPush,
					meta: {
						loginRequerido: true,
						permissao: 173			
					}      
				},
				{
					path: '/cadastros/feriados',
					component: Feriados,
					meta: {
						loginRequerido: true,
						permissao: 33			
					}             
				},		
				{
					path: '/cadastros/centros-custos',
					component: CentrosCustos,
					meta: {
						loginRequerido: true,
						permissao: 14			
					}             
				},			
				{
					path: '/cadastros/cargos',
					component: Cargos,
					meta: {
						loginRequerido: true,
						permissao: 19			
					}             
				},
				{
					path: '/cadastros/escalas-horarios',
					component: Escalas,
					meta: {
						loginRequerido: true,
						permissao: 70			
					},
					children: [
						{path: '', component: ListaEscalas, meta: {loginRequerido: true, permissao: 70}},
						{path: 'novo', component: NovaEscala, meta: {loginRequerido: true, permissao: 71}},
						{path: ':id/editar', component: NovaEscala, props: true, meta: {loginRequerido: true, permissao: 72}}
					]             
				},
				{
					path: '/cadastros/funcionarios',
					component: Funcionarios,
					meta: {
						loginRequerido: true,
						permissao: 24			
					},
					children: [
						{path: '', component: ListaFuncionarios, meta: {loginRequerido: true, permissao: 24}},
						{path: 'novo', component: NovoFuncionario, meta: {loginRequerido: true, permissao: 25}},
						{path: ':id/editar', component: EditaFuncionario, props: true, meta: {loginRequerido: true, permissao: 26}},
						{path: 'importar', component: ImportarFuncionarios, props: true, meta: {loginRequerido: true, permissao: 26},
							children: [
								{path: '', component: Orientacoes, meta: {loginRequerido: true, permissao: 70}},
								{path: 'configurar', component: Configurar, meta: {loginRequerido: true, permissao: 70}},
								{path: 'validar', component: Validar, meta: {loginRequerido: true, permissao: 71}},
								{path: 'confirmar', component: Confirmar, props: true, meta: {loginRequerido: true, permissao: 72}},
								{path: 'finalizar', component: Finalizar, props: true, meta: {loginRequerido: true, permissao: 72}}
							]
						}
					]             
				},
				{
					path: '/cadastros/escalas-folgas',
					component: EscalaFolga,
					meta: {
						loginRequerido: true,
						permissao: 95			
					}             
				},	
				{
					path: '/cadastros/justificativas',
					component: Justificativas,
					meta: {
						loginRequerido: true,
						permissao: 90			
					}             
				},	
				{
					path: '/cadastros/motivos-afastamento',
					component: MotivoAfastamentos,
					meta: {
						loginRequerido: true,
						permissao: 75
					}
				},				
				{
					path: '/movimento/afastamentos',
					component: Afastamentos,
					meta: {
						loginRequerido: true,
						permissao: 102
					}
				},
				{
					path: '/movimento/calculo-ponto',
					component: CalculoPonto,
					meta: {
						loginRequerido: true,
						permissao: 125
					}
				},
				{
					path: '/movimento/ocorrencias',
					component: Ocorrencias,
					meta: {
						loginRequerido: true,
						permissao: 108
					}
				},
				{
					path: '/movimento/mudanca-horario',
					component: MudancaHorario,
					meta: {
						loginRequerido: true,
						permissao: 115
					}
				},
				{
					path: '/movimento/banco-horas',
					component: BancoHoras,
					meta: {
						loginRequerido: true,
						permissao: 120
					}
				},
				{
					path: '/movimento/concluir-fechar-periodo',
					component: ConcluirFecharPerido,
					meta: {
						loginRequerido: true,
						permissao: 150
					}
				},
				{
					path: '/movimento/controle-ponto',
					component: ControlePonto,
					meta: {
						loginRequerido: true,
						permissao: 126
					},
					children: [
						{path: '', component: Controle, meta: {loginRequerido: true, permissao: 126}},
						{path: 'marcacoes', component: MarcacoesFuncionario, meta: {loginRequerido: true, permissao: 127}},
					] 
				},
				{
					path: '/movimento/solicitacoes',
					component: Solicitacoes,
					meta: {
						loginRequerido: true,
						permissao: 165
					}
				},
				{
					path: '/relatorios',
					component: Relatorios,
					meta: {
						loginRequerido: true,
						permissao: 128
					},
					children: [						
						{path: 'divergencias', component: Divergencias, meta: {loginRequerido: true, permissao: 130}},
						{path: 'espelho-ponto', component: EspelhoPonto, props: true, meta: {loginRequerido: true, permissao: 129}},
						{path: 'horas-trabalhadas', component: HorasTrabalhadas, props: true, meta: {loginRequerido: true, permissao: 131}},
						{path: 'horas-extras-analitico', component: HorasExtrasAnalitico, props: true, meta: {loginRequerido: true, permissao: 132}},
						{path: 'interjornada', component: Interjornada, props: true, meta: {loginRequerido: true, permissao: 136}},
						{path: 'intervalo-almoco', component: IntervaloAlmoco, props: true, meta: {loginRequerido: true, permissao: 137}},
						{path: 'domingos-trabalhados', component: DomingosTrabalhados, props: true, meta: {loginRequerido: true, permissao: 139}},
						{path: 'saldo-banco-horas', component: SaldoBancoHorasRelatorio, props: true, meta: {loginRequerido: true, permissao: 139}},	
						{path: 'ponto-externo', component: PontoExterno, props: true, meta: {loginRequerido: true, permissao: 147}},
						{path: 'maracacoes-local-relogio', component: MarcacoesLocalRelogio, props: true, meta: {loginRequerido: true, permissao: 147}},
						{path: 'ocorrencias-justificadas', component: OcorrenciaJustificada, props: true, meta: {loginRequerido: true, permissao: 164}},	
						{path: 'historico', component: HistoricoRelatorios, meta: {loginRequerido: true, permissao: 0}},				
					]  
				},
				{
					path: '/documentos',
					component: Documentos,
					meta: {
						loginRequerido: true,
						permissao: 133
					},
					children: [						
						{path: 'arquivo-afd', component: ArquivoAFD, meta: {loginRequerido: true, permissao: 134}},
						{path: 'arquivo-fiscal', component: ArquivoFiscal, meta: {loginRequerido: true, permissao: 135}},
						{path: 'arquivo-folha', component: ArquivoFolha, meta: {loginRequerido: true, permissao: 158}},	
						{path: 'comprovante-marcacao', component: ComprovanteMarcacao, meta: {loginRequerido: true, permissao: 172}},	
						{path: 'historico', component: HistoricoRelatorios, meta: {loginRequerido: true, permissao: 0}},							
					]  
				},				
				{
					path: '/conta/meus-dados',
					component: MeusDados,
					meta: {
						loginRequerido: true,
						permissao: 10
					}
				},	
				{
					path: '/sistema/usuarios',
					component: Usuarios,
					meta: {
						loginRequerido: true,
						permissao: 2			
					},
					children: [
						{path: '', component: ListaUsuarios, meta: {loginRequerido: true, permissao: 2}},						
						{path: ':id/editar', component: EditarUsuario, props: true, meta: {loginRequerido: true, permissao: 4}}
					]             
				},	
				{
					path: '/sistema/logs-operacoes',
					component: LogOperacao,
					meta: {
						loginRequerido: true,
						permissao: 12
					}
				},
				{
					path: '/sistema/perfis-permissoes',
					component: PerfilPermissao,
					meta: {
						loginRequerido: true,
						permissao: 7
					}
				},
				{
					path: '/sistema/politica-privacidade',
					component: PoliticaPrivacidade,
					meta: {
						loginRequerido: true,
						permissao: 7
					}
				},
				{
					path: '/sistema/autorizacao-suporte',
					component: AutorizacaoSuporete,
					meta: {
						loginRequerido: true,
						permissao: 0
					}
				},
				{
					path: '/sistema/noticias',
					component: Mensagem,
					meta: {
						loginRequerido: true,
						permissao: 0
					}
				},
				{
					path: '/sistema/sobre',
					component: Sobre,
					meta: {
						loginRequerido: true,
						permissao: 0
					}
				},
			]        
		},		
		{			
			path: '/login',
			component: Login,
			meta: {
				loginRequerido: false,				
			}             
		},
		{			
			path: '/esqueci-senha',
			component: SolicitarTrocarSenha,
			meta: {
				loginRequerido: false,				
			}             
		},
		{			
			path: '/redefinir-senha-email',
			component: TrocarSenha,
			meta: {
				loginRequerido: false,				
			}             
		},
		{
			path: '*',
			component: Erro404
		},
		{			
			path: '/nao-autorizado',
			component: NaoAutorizado,
			meta: {
				loginRequerido: false,				
			}             
		}	
	],
	scrollBehavior() {
		return {x: 0, y: 0};
	}
});

router.beforeEach((to, from, next) => {	
	// Incluindo esse atributo (urlAnteriorSelecionada), global, para controle de dados na sessão ou local do storage.
	window.urlAnteriorSelecionada = from.path;	
	let isAutenticado = store.getters['sessao/getIsAutenticado'];		
	if(to.matched.some(record => record.meta.loginRequerido)) {	
		let permissoes = store.getters['sessao/getPermissoes'];		
		if(!isAutenticado) {	
			next({
				path: '/login',
				query: { redirect: to.fullPath }
			});	
		} else if(permissoes.includes(to.meta.permissao)){		
			next();				
		} else {
			next({
				path: '/nao-autorizado',
				query: { redirect: to.fullPath }
			});	
		}
	} else if(isAutenticado && to.path == '/login') {			
		next('/');
	} else {	
		next();
	}
});

export default router;
